import React, { useState, useEffect } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/config';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';
import { saveCandidate } from '../Api';

const SignupPage = () => {
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageVisible, setMessageVisible] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem('loggedInUserId');
    if (userId) {
      navigate('/');
    }
  }, [navigate]);

  // Disable right-click and common inspect shortcuts
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
  
    const handleKeyDown = (e) => {
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey || e.metaKey) && 
        (e.shiftKey && ['I', 'J', 'C', 'K'].includes(e.key.toUpperCase()))
      ) {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey || e.metaKey) &&
        ['U', 'S', 'P'].includes(e.key.toUpperCase())
      ) {
        e.preventDefault();
        return false;
      }
    };
  
    window.addEventListener('contextmenu', handleContextMenu);
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const showMessage = (text, isError = false) => {
    setMessage(text);
    setMessageVisible(true);
    const color = isError ? 'red' : 'green';
    document.getElementById('signInMessage').style.color = color;

    setTimeout(() => {
      setMessageVisible(false);
    }, 5000);
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const result = await createUserWithEmailAndPassword(auth, email, password);
      const userId = result.user.uid;
      const nameParts = fullName.trim().split(' ');
      const firstName = nameParts[0];
      const lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';

      await setDoc(doc(db, "candidates", userId), {
        uid: userId,
        fullName,
        firstName,
        lastName,
        phone,
        email,
        createdAt: new Date()
      });

      const res = await saveCandidate({
        uid: userId,
        fullName,
        firstName,
        lastName,
        phone,
        email,
      });

      // console.log("SaveCandidate API response:", res);

      localStorage.setItem('loggedInUserId', userId);
      showMessage('Signup successful!');
      setTimeout(() => navigate('/'), 2000);
    } catch (error) {
      let message = '';
    
      switch (error.code) {
        case 'auth/email-already-in-use':
          message = 'This email is already registered. Please log in instead.';
          break;
        case 'auth/invalid-email':
          message = 'The email address is invalid. Please check and try again.';
          break;
        case 'auth/operation-not-allowed':
          message = 'Email/password accounts are not enabled. Contact support.';
          break;
        case 'auth/weak-password':
          message = 'The password is too weak. Please use at least 6 characters.';
          break;
        case 'auth/missing-email':
          message = 'Email is required.';
          break;
        case 'auth/internal-error':
          message = 'Unexpected server error. Please try again later.';
          break;
        case 'auth/network-request-failed':
          message = 'Network error. Please check your internet connection.';
          break;
        default:
          message = `Signup failed: ${error.message}`;
          break;
      }
    
      showMessage(message, true);
    }
    
  };

  return (
    <>
      <Header />
      <div className="login-page" style={{ backgroundColor: '#FFFDF6'}}>
        <div className="container d-flex align-items-center vh-100">
          <div className="form-holder shadow-lg w-100">
            <div className="row">
              {/* Info Panel */}
              <div className="col-lg-6 position-relative text-center" style={{ backgroundColor: '#113d6e'}}>
                <img src="/images/logofs.png" alt="logo" width="250" height="180" className="position-absolute top-0 start-50 translate-middle-x mt-5 d-lg-block d-none"/>
                <div className="info d-flex flex-column justify-content-center h-100 text-light">
                  <div className="content d-lg-block d-none">
                    <h1>Signup Now</h1>
                  </div>
                  <div
                    id="signInMessage"
                    className="messageDiv"
                    style={{
                      display: messageVisible ? 'block' : 'none',
                      opacity: messageVisible ? 1 : 0,
                      transition: 'opacity 0.5s',
                      marginTop: '10px'
                    }}
                  >
                    {message}
                  </div>
                </div>
                <img src="/images/india.png" alt="india" width="100%" className="position-absolute bottom-0 start-0"/>
              </div>

              {/* Form Panel */}
              <div className="col-lg-6 bg-white d-flex align-items-center p-5">
                <div className="w-100 px-4">
                  <form onSubmit={handleSignup}>
                    <h2 className="mb-5">Signup</h2>

                    <div className="form-group mb-3">
                      <label>Full Name</label>
                      <input
                        type="text"
                        className="form-control"
                        required
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        placeholder="Enter your full name"
                      />
                    </div>

                    <div className="form-group mb-3">
                      <label>Phone Number</label>
                      <input
                        type="tel"
                        className="form-control"
                        required
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="Enter your phone number"
                      />
                    </div>

                    <div className="form-group mb-3">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter email address"
                      />
                    </div>

                    <div className="form-group mb-3">
                      <label>Password</label>
                      <input
                        type="password"
                        className="form-control"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Choose a password"
                      />
                    </div>

                    <div className="text-center">
                      <button type="submit" className="btn btn-info">Signup</button>
                    </div>
                  </form>

                  <div className="text-center mt-3">
                    <small>Already have an account?</small> <a href="/login">Login</a>
                    <p className="mb-0 mt-4">&copy; {new Date().getFullYear()} Freshskills. All rights reserved.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>  
      </div>
      <Footer />
    </>
  );
};

export default SignupPage;
